module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_5"
    }
  }, [_c('span', [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("THE “SNOW")]), _vm._v(" Circus” had at least quadrupled in size over the past few years.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At first, the empty parking lot overlooking the river had three, maybe "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("four ")]), _vm._v("booths at most. One selling paintings, one selling nubby wool socks, one selling cups of steaming chili. The clientele mainly consisted of people who wanted to see the frozen river and needed a reason to linger and make the stroll worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That changed when the city added an honest-to-goodness skating rink.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It became a local attraction. Lights and wreaths went up around the rink, free-standing propane heaters were added with clusters of café tables and seating, and those little winter-themed sales booths multiplied like rabbits.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Far as he was concerned, it was a no-brainer to try to shop for a present there, but the pushy crowd was definitely a con rather than a pro for Kyle. Given the holiday rush, it was likely to be an elbow-happy marathon of “Excuse me” and “Sorry, can I just—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Even worse, Kyle stood a fair chance at running into someone who knew him. He could see it now. “Kyle Zigler, is that you? Hey, how ya doing? How are the kids this year? We keep meaning to invite you for dinner sometime.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Or even worse: “Hey, Kyle, are you still working on computers? Listen, my laptop’s acting kind of slow, would you be willing to take a crack at it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That he couldn’t stand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Still, nothing was worse than the time he’d run into an old classmate at the local grocery store. “Kyle, hey bud. You’re still single, right? So, uhhh…. my cousin just came out, and he doesn’t really know anyone, y’know, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("on the rainbow team.")]), _vm._v(" I was wondering if you’d like to maybe hang out with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle considered going into witness protection after that one. Faking his own death wasn’t as far out of the question as it should have been.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The Snow Circus was in a quaint little spot at the very north side of town, surrounded by lush pines so only the distant twinkle of street lights was visible. At the front gate, the promoters had erected a series of angled blue and silver curtains so it actually looked like the entrance to a circus tent. The rest of the decor was similarly deep blue and silver, from the ribbons to the tree lights. The effect it created, especially when reflected from the river, was definitely worth a chilly stroll.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("During December, the whole town ended up passing through pretty often. Nowadays, high schoolers brought their dates here for a wander and some cocoa. And most parents felt comfortable bringing their kids here to turn loose on the rink.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The booths showcased local farmers and artists. Several cool food trucks dotted the area, everything from vegan BBQ to fried marshmallows. One booth featured custom-made sweatshirts, another that offered homemade candles, one that sold raw crystals for either geology enthusiasts or New Agers. There were even oddball specialties, like a pair of sisters who made festive containers of slime that were popular for both children soothed by stimming or anyone who liked playing with colorful goo. Last year, Kyle even saw a stall that sold tiny little plant biomes in glass jars, a completely self-sustaining ecosystem.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Alice and Zach weren’t the kinds of kids who’d have their minds blown by the latest gizmo from the mall. The Snow Circus offered the kinds of unexpected gifts they would "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("love.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To Kyle’s profound relief, the crowds weren’t too bad. It helped that it was a weekday.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle relaxed when he realized he didn’t recognize anyone, except perhaps the booth owners. Following his usual strategy, he went straight to one of the hot drink stalls to buy a paper cup of peppermint coffee. People seemed less likely to play the eager salesman when he already had something in his hands. Besides, he liked to browse through all the booths before committing to a purchase.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Excuse me, sir? Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle started and whirled around, hands patting his pockets. Had he dropped something? Was he in someone’s way? His eyes caught the bright gaze of a young man in a booth, staring directly at him with a half-smile on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Wow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The vendor asked him something, but Kyle didn’t quite hear him. The man was breathtakingly beautiful, as if he were behind a real-life Instagram filter. The combination of light blond hair and chiseled facial features made the stranger, at a glance, look otherworldly. His skin had a faint golden cast to it, as if the sunlight that bleached his hair had also tanned his skin. A thin but tasteful mustache-goatee combination made him look a little rakish, accentuating angles that frankly didn’t need a lot of help in the first place. He had broad and toned shoulders, and his gray turtleneck "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("absolutely ")]), _vm._v("did"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("not hide the definition of his biceps and pectorals.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle froze, staring at the young man like the proverbial deer in headlights.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Finally, the expectant silence between them stretched long enough to seem comical. “Sorry. Beg your pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The young man chuckled. There was nothing mocking in it. “I was saying I’ve got the perfect scarf for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Scarf?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Blinking away his daze, Kyle looked around the booth he’d unknowingly drifted in front of. It was full of handsome handmade scarves, varying from patterns to full scenes woven into them. Kyle recognized the Seattle Space Needle, the Toronto CN Tower, Big Ben…. Others featured tartans, trees, monsters, mountains, and mushrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They were certainly ambitious scarf designs, elaborate even, but somehow none of them looked overly "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("busy. ")]), _vm._v("The colors, generally two-toned, were complementary and subtle enough to not clash with most patterns or styles.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had to admit, he liked them a lot. But he wasn’t there for himself and he couldn’t possibly afford something that extravagant with money so tight. “Oh, oh—thank you. I’m actually just browsing, though. I’ve only just got here—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The young man waved away his protests. He plucked one of the scarves from his wall and turned back to Kyle. His bold, precise movements reminded Kyle a bit of an athlete or a dancer… a kind of casual grace as if the world choreographed itself around his gestures. In one fluid motion, the young man wrapped the beautiful scarf around Kyle’s neck, taking a moment to adjust it over his coat. “There! See? This was practically "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("made ")]), _vm._v("for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle looked down. The deep black scarf featured gray snowflakes tumbling down. But on closer inspection, they weren’t just snowflakes. Tiny cursive script made up the shape of the flakes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("“I am not to speak to you, I am to think of you when I am alone or")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("wake at night alone")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I am to wait. I do not doubt that I will meet you again.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I am to see to it that I do not lose you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A tiny thrill went through Kyle. “Walt Whitman!” he exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The young man beamed. “Ah, a gentleman and a scholar.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle could feel a blush forming but hoped the cold could serve as an excuse. It also occurred this handsome guy might be flirting, testing "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("where ")]), _vm._v("Kyle fell on the gay spectrum. Or not. Walt Whitman was at least somewhat innocuous. If the guy started a conversation about Oscar Wilde or gym memberships or rainbow decor, it would be more on the nose. “It’s gorgeous,” Kyle said after a moment. “I’m not really shopping for me, though. I love the scarf, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The young man held up a hand, shaking his head. “No, no. No charge. It’s a gift. Talk about product placement.” He winked in a way that warmed Kyle’s cheeks. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Definitely")]), _vm._v(" flirting then. “Just, y’know, if someone asks where you got that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("awesome ")]), _vm._v("handmade scarf, just mention that you got it from Vic’s Creations booth. Consider it a Christmas blessing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic. That was his name.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle reached up and ran his fingers over the fabric. It was impossibly soft, probably with a thread count to make any luxury hotel jealous. “You’re just starting out?” Kyle ventured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah.” Vic folded his arms over his powerful chest, leaning back on his display table. “Well, kind of. I’ve been making stuff like this for years, but I’m not really established in this area yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle nodded slowly. A few shoppers approached the booth, pointing and gushing over the scarves. Vic greeted them with a confident manner as Kyle watched.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It looked so easy for Vic, while Kyle was scrambling for another conversation topic when the potential buyers called “We’ll be back.” with a wave.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So, you’re, ah. You’re new here?” Kyle asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic laughed. With most people, Kyle would have the distinct impression he was being made fun of. But he didn’t get that vibe from Vic. It was more like they were sharing the joke, just the two of them. “Why do you ask? Don’t I look like a born and raised local?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You look like you’re familiar with sunlight. That’s why I asked.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That I am. Never met a sunrise I didn’t love. I’m fresh from California.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle blinked. “You moved here from—? But why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic grinned. Kyle could sense he got that question a lot. “San Fransisco got too played out. I wanted some seasons. You only need to live there for a couple of years before you’ve seen everything, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("A couple of years? ")]), _vm._v("“Where were you before that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Charleston. And before that, Austin. Denver just before that. Went to high school in Ohio—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not ")]), _vm._v("my choice.” He sounded firm on that point. “I always wondered why that state produces such a shocking of astronauts and serial killers. Well, now I know—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Something in the water?” Kyle couldn’t help teasing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nah. More like something missing… from everything. The whole place just activates your fight or flight response.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle laughed. Generally, at this point in the conversation he’d be fumbling for some way out, an excuse or a lifeline. But talking with Vic was—surprisingly easy. He was having "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("fun.")]), _vm._v(" “That’s a lot of moving around,” Kyle noted. “Was it for work? Or military?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic shook his head, and ran his hands through his blond curls. “I just… kept getting bored, I guess. I’m kind of a restless person. When my sis had a room open up here, I figured I could use a change of pace. Especially for the holidays, y’know? It’s nice to have family around.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle let out a whoosh of breath. Changing his environment on a whim? He couldn’t imagine it. Even the idea made him queasy. “And here I am, still coming to terms with the conversion from VHS to DVD.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic’s impish smile spread all the way to his eyes and hinted at just a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("bit ")]), _vm._v("of mischief. “I take it you’re from around these parts, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Born and raised.” Kyle felt almost sheepish to admit it. In fact, he’d only been out of the state a handful of times on childhood vacations.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, maybe you can help me, because I’m curious.” Vic was suddenly at Kyle’s side. He pointed toward the very front of the market and, with his other hand, lightly squeezed Kyle’s shoulder with strong fingers. It felt impossibly startling and warm through the thick fabric of Kyle’s wool coat. “Snow Circus. Is it named for that tent structure there? Or is a tiny car filled with clowns going to pull up that I should be worried about?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic released his grip on Kyle’s shoulder, and it took Kyle a moment to get his bearings. “Ah, uh. No, actually. The circus tent entryway came after the name.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really?” Vic’s nose wrinkled as he pondered this. “Why the Snow Circus?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No idea. Maybe they figured Winter Wonderland was overdone. And Santa’s Shopping Shacks might’ve attracted a sketchy crowd.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So I don’t need to be on the lookout for any overloaded clown cars?” He leaned closer and actually "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("winked")]), _vm._v(". “Clowns freak me out big time.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re safe. They all drive south for the winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The laugh that startled out of Vic made Kyle feel as if he’d just won an award. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("And the Oscar for ‘Fumbling Their Way Through a Conversation’ goes to….")]), _vm._v(" Kyle thought he could keep chatting with this charming stall owner for the rest of the afternoon. But what was that saying about quitting while you were ahead? “Well, I’d better grab what I came for before my lunch break ends. A genuine pleasure meeting you. Vic, was it?” When Vic nodded, Kyle pressed on, savoring the warm connection as it came near its end. “Is that short for anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vic struck a pose, holding up his arms and waving his hands in a facetious gesture. “Vic-tim of my own insatiable wanderlust?” he quipped. “Just call me Vic.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle had a feeling he wasn’t the first recipient of that joke, but it didn’t dampen the delivery. He wasn’t sure anything could. “Thank you,” he said haltingly. “It was fantastic meeting you. Really. Thanks, Vic.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The feeling is mutual.” Vic smiled warmly. “I appreciate you adding to the Christmas cheer. Not to mention modeling my wares.” He leaned in to straighten and place the scarf, his knuckles brushing Kyle’s chest in a way that made him hold his breath. Vic paused and stepped back, squinting at the results. “You look… very dashing,” he murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Their eyes caught and held for more than a moment. Surely, this "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("had")]), _vm._v(" to be flirting, like on-purpose, full-scale frontal assault, wanna-get-a-drink-later-cause-I-have-a crush invitation. Or was it?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle gulped, nodded, and left before he did or said anything crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("As he threaded through the rest of the market, Kyle tried his best not to look anywhere near Vic’s booth. He mostly succeeded—anytime he did glance back, he saw Vic chatting pleasantly with another potential buyer. It was hard to tell from a distance, but he didn’t think he gave anyone else a free scarf.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3509737a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0005.vue
// module id = 69
// module chunks = 0